import { InitialGeneralState } from 'interfaces/general.interface';

const initialGeneralState: InitialGeneralState = {
  ping: true,
  setPing: () => {},
  isLoadingSetPing: true,
  exchanges: [],
  countries: [],
  associationStates: null,
  // Points of sale categories
  isLoadingPointsOfSaleCategories: false,
  pointsOfSaleCategories: [],
  selectCategory: () => {},
  categorySelected: null,
  createCategory: () => Promise.resolve(false),
  isLoadingCreateCategory: false,
  updateCategory: () => Promise.resolve(false),
  isLoadingUpdateCategory: false,
  deleteCategory: () => Promise.resolve(false),
  isLoadingDeleteCategory: {
    categoryId: '',
    isLoading: false,
  },
};

export default initialGeneralState;
